import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withKeys as _withKeys, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-77c0e5b5"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "row-value" };
const _hoisted_2 = {
    key: 0,
    class: "optional"
};
const _hoisted_3 = { class: "row-value name-column sub-row-value" };
const _hoisted_4 = { class: "name viewer" };
const _hoisted_5 = { class: "description" };
const _hoisted_6 = { class: "variable-quantity-text" };
const _hoisted_7 = { class: "modifier-menu" };
const _hoisted_8 = {
    key: 1,
    class: "value"
};
const _hoisted_9 = {
    key: 1,
    class: "formatted-tax-text",
    "data-external": "editor-pricing-table-row-value-tax"
};
const _hoisted_10 = {
    key: 2,
    class: "value"
};
const _hoisted_11 = { class: "row-value name-column" };
const _hoisted_12 = { class: "header" };
const _hoisted_13 = {
    key: 0,
    class: "optional-view"
};
const _hoisted_14 = { class: "description" };
const _hoisted_15 = { class: "header" };
const _hoisted_16 = { class: "variable-quantity-text" };
const _hoisted_17 = { class: "modifier-menu" };
const _hoisted_18 = {
    key: 1,
    class: "value"
};
const _hoisted_19 = {
    key: 1,
    class: "row-value total-price-column"
};
const _hoisted_20 = { class: "total-price-container" };
const _hoisted_21 = { class: "header" };
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "row-divider" }, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_PricingTableCheckbox = _resolveComponent("PricingTableCheckbox");
    const _component_PricingTableDescriptionInput = _resolveComponent("PricingTableDescriptionInput");
    const _component_FriedIcon = _resolveComponent("FriedIcon");
    const _component_PricingTableUnitsModifierMenu = _resolveComponent("PricingTableUnitsModifierMenu");
    const _component_FriedFloater = _resolveComponent("FriedFloater");
    const _directive_click_outside = _resolveDirective("click-outside");
    return (_openBlock(), _createElementBlock("div", null, [
        (!_ctx.isBlockWidthSmall)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["rows-container", { optional: _ctx.hasOptionalProductDeselected }]),
                style: _normalizeStyle(_ctx.gridTemplateColumns)
            }, [
                _createElementVNode("div", _hoisted_1, [
                    (_ctx.getRowOptionalProductEnabled(_ctx.row, _ctx.fields))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createVNode(_component_PricingTableCheckbox, {
                                input: _ctx.rowOptionalProductInputField(),
                                disabled: !_ctx.isEditable,
                                onUpdateChecked: _ctx.handleUpdateChecked
                            }, null, 8, ["input", "disabled", "onUpdateChecked"])
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.getRowNameValue(_ctx.columns, _ctx.getRowValues(_ctx.row))), 1),
                        _withDirectives(_createElementVNode("div", _hoisted_5, [
                            _createVNode(_component_PricingTableDescriptionInput, {
                                "merge-values": _ctx.mergeValues,
                                fields: _ctx.fields,
                                content: _ctx.getRowDescriptionValue(_ctx.columns, _ctx.getRowValues(_ctx.row))
                            }, null, 8, ["merge-values", "fields", "content"])
                        ], 512), [
                            [_vShow, _ctx.showDescription]
                        ]),
                        _withDirectives(_createElementVNode("div", { class: "sku" }, _toDisplayString(_ctx.getRowSkuValue(_ctx.columns, _ctx.getRowValues(_ctx.row))), 513), [
                            [_vShow, _ctx.showSku]
                        ])
                    ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getFilteredRowValues(_ctx.row, _ctx.columns), (rowValue) => {
                    return (_openBlock(), _createElementBlock("div", {
                        key: rowValue.columnId,
                        class: _normalizeClass([
                            'row-value',
                            {
                                strikethrough: _ctx.hasOptionalProductDeselected,
                                'custom-row': _ctx.hasCustomColumn(_ctx.columns, rowValue.columnId),
                            },
                        ])
                    }, [
                        (rowValue.columnId === _ctx.getColumnIdFromName(_ctx.columns, _ctx.EPricingTableColumn.Units) &&
                            _ctx.getRowVariableQuantityEnabled(_ctx.row, _ctx.fields))
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (!_ctx.hasRecipientSigned(_ctx.recipientStatus) && _ctx.allowedToEditAfterPartiallySigned)
                                    ? _withDirectives((_openBlock(), _createBlock(_component_FriedFloater, {
                                        key: 0,
                                        show: _ctx.showVariableQuantityMenu,
                                        "append-to-body": false,
                                        placement: "bottom-end",
                                        class: "variable-quantity-container"
                                    }, {
                                        reference: _withCtx(() => [
                                            _createElementVNode("div", {
                                                class: "variable-quantity-value",
                                                tabindex: "0",
                                                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.showVariableQuantityMenu = !_ctx.showVariableQuantityMenu)),
                                                onKeydown: _cache[1] || (_cache[1] = _withKeys(($event) => (_ctx.showVariableQuantityMenu = true), ["enter", "space"]))
                                            }, [
                                                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.rowVariableQuantityField.value), 1),
                                                _createVNode(_component_FriedIcon, {
                                                    class: _normalizeClass(['chevron', { opened: _ctx.showVariableQuantityMenu }]),
                                                    icon: "chevron-down"
                                                }, null, 8, ["class"])
                                            ], 32)
                                        ]),
                                        default: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_7, [
                                                _createVNode(_component_PricingTableUnitsModifierMenu, {
                                                    "input-field": _ctx.rowVariableQuantityField,
                                                    disabled: _ctx.isDocumentView,
                                                    open: _ctx.showVariableQuantityMenu,
                                                    onUpdateField: _ctx.handleUpdateVariableQuantityField,
                                                    onClose: _cache[2] || (_cache[2] = ($event) => (_ctx.showVariableQuantityMenu = false))
                                                }, null, 8, ["input-field", "disabled", "open", "onUpdateField"])
                                            ])
                                        ]),
                                        _: 1
                                    }, 8, ["show"])), [
                                        [_directive_click_outside, _ctx.handleCloseVariableQuantityMenu]
                                    ])
                                    : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.rowVariableQuantityField.value), 1))
                            ], 64))
                            : (rowValue.columnId === _ctx.getColumnIdFromName(_ctx.columns, _ctx.EPricingTableColumn.Tax))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.getRowFormattedTax(_ctx.row, _ctx.columns, _ctx.currencySettings)), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.getFormat(rowValue)), 1))
                    ], 2));
                }), 128)),
                (_ctx.showTotalPrice)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.isPreCalculated)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                "data-external": "total-price-column",
                                class: _normalizeClass(["row-value total-price-column", { precalculated: _ctx.isPreCalculated }])
                            }, [
                                _createElementVNode("div", {
                                    class: _normalizeClass(['total-price', { strikethrough: _ctx.hasDiscount(_ctx.columns, _ctx.getRowValues(_ctx.row)) }])
                                }, _toDisplayString(_ctx.getFormattedPrice(_ctx.getRowTotalPrice(_ctx.isPreCalculated, _ctx.row, _ctx.columns, _ctx.fields))), 3),
                                _withDirectives(_createElementVNode("div", {
                                    tabindex: "0",
                                    class: _normalizeClass(["discount", { empty: _ctx.getRowDiscountValueIsEmpty(_ctx.columns, _ctx.getRowValues(_ctx.row)) }])
                                }, _toDisplayString(_ctx.getRowFormattedDiscount(_ctx.isPreCalculated, _ctx.row, _ctx.columns, _ctx.fields, _ctx.currencySettings)), 3), [
                                    [_vShow, _ctx.showDiscount]
                                ]),
                                _withDirectives(_createElementVNode("div", {
                                    class: _normalizeClass(['discounted-price'])
                                }, _toDisplayString(_ctx.getFormattedPrice(_ctx.getRowNetPrice(_ctx.isPreCalculated, _ctx.row, _ctx.columns, _ctx.fields))), 513), [
                                    [_vShow, _ctx.showDiscount]
                                ])
                            ], 2))
                            : (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: _normalizeClass(['row-value total-price-column', { strikethrough: _ctx.hasOptionalProductDeselected }]),
                                "data-external": "total-price-column"
                            }, [
                                _createElementVNode("div", {
                                    class: _normalizeClass(["total-price", { strikethrough: _ctx.hasDiscount(_ctx.columns, _ctx.getRowValues(_ctx.row)) }])
                                }, _toDisplayString(_ctx.currencyFormat(_ctx.getRowTotalPrice(_ctx.isPreCalculated, _ctx.row, _ctx.columns, _ctx.fields), _ctx.currencySettings)), 3),
                                _withDirectives(_createElementVNode("div", {
                                    tabindex: "0",
                                    class: _normalizeClass(["discount", { empty: _ctx.getRowDiscountValueIsEmpty(_ctx.columns, _ctx.getRowValues(_ctx.row)) }])
                                }, _toDisplayString(_ctx.getRowFormattedDiscount(_ctx.isPreCalculated, _ctx.row, _ctx.columns, _ctx.fields, _ctx.currencySettings)), 3), [
                                    [_vShow, _ctx.showDiscount]
                                ]),
                                _withDirectives(_createElementVNode("div", { class: "discounted-price" }, _toDisplayString(_ctx.currencyFormat(_ctx.getRowNetPrice(_ctx.isPreCalculated, _ctx.row, _ctx.columns, _ctx.fields), _ctx.currencySettings)), 513), [
                                    [_vShow, _ctx.hasDiscount(_ctx.columns, _ctx.getRowValues(_ctx.row))]
                                ])
                            ], 2))
                    ], 64))
                    : _createCommentVNode("", true)
            ], 6))
            : _createCommentVNode("", true),
        (_ctx.isBlockWidthSmall)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "rows-container cards",
                style: _normalizeStyle(_ctx.gridTemplateColumns)
            }, [
                _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.getColumnDisplayName(_ctx.getColumnIdFromName(_ctx.columns, _ctx.EPricingTableColumn.Name), _ctx.columns)), 1),
                    _createElementVNode("div", {
                        class: _normalizeClass(['name', { 'optional-product': _ctx.getRowOptionalProductEnabled(_ctx.row, _ctx.fields) }])
                    }, [
                        (_ctx.getRowOptionalProductEnabled(_ctx.row, _ctx.fields))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _createVNode(_component_PricingTableCheckbox, {
                                    input: _ctx.rowOptionalProductInputField(),
                                    disabled: !_ctx.isEditable,
                                    onUpdateChecked: _ctx.handleUpdateChecked
                                }, null, 8, ["input", "disabled", "onUpdateChecked"])
                            ]))
                            : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(_ctx.getRowNameValue(_ctx.columns, _ctx.getRowValues(_ctx.row))), 1)
                    ], 2),
                    _withDirectives(_createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_PricingTableDescriptionInput, {
                            "merge-values": _ctx.mergeValues,
                            fields: _ctx.fields,
                            content: _ctx.getRowDescriptionValue(_ctx.columns, _ctx.getRowValues(_ctx.row))
                        }, null, 8, ["merge-values", "fields", "content"])
                    ], 512), [
                        [_vShow, _ctx.showDescription]
                    ]),
                    _withDirectives(_createElementVNode("div", { class: "sku" }, _toDisplayString(_ctx.getRowSkuValue(_ctx.columns, _ctx.getRowValues(_ctx.row))), 513), [
                        [_vShow, _ctx.showSku]
                    ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getFilteredRowValues(_ctx.row, _ctx.columns), (rowValue) => {
                    return (_openBlock(), _createElementBlock("div", {
                        key: rowValue.columnId,
                        class: _normalizeClass([
                            'row-value',
                            { 'custom-row-column-format': _ctx.hasCustomColumn(_ctx.columns, rowValue.columnId) },
                        ])
                    }, [
                        _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.getColumnDisplayName(rowValue.columnId, _ctx.columns)), 1),
                        (rowValue.columnId === _ctx.getColumnIdFromName(_ctx.columns, _ctx.EPricingTableColumn.Units) &&
                            _ctx.getRowVariableQuantityEnabled(_ctx.row, _ctx.fields))
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (!_ctx.hasRecipientSigned(_ctx.recipientStatus) && _ctx.allowedToEditAfterPartiallySigned)
                                    ? _withDirectives((_openBlock(), _createBlock(_component_FriedFloater, {
                                        key: 0,
                                        show: _ctx.showVariableQuantityMenu,
                                        "append-to-body": false,
                                        placement: "bottom-end",
                                        class: "variable-quantity-container"
                                    }, {
                                        reference: _withCtx(() => [
                                            _createElementVNode("div", {
                                                class: "variable-quantity-value",
                                                tabindex: "0",
                                                onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.showVariableQuantityMenu = !_ctx.showVariableQuantityMenu)),
                                                onKeydown: _cache[4] || (_cache[4] = _withKeys(($event) => (_ctx.showVariableQuantityMenu = true), ["enter", "space"]))
                                            }, [
                                                _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.rowVariableQuantityField.value), 1),
                                                _createVNode(_component_FriedIcon, {
                                                    class: _normalizeClass(['chevron', { opened: _ctx.showVariableQuantityMenu }]),
                                                    icon: "chevron-down"
                                                }, null, 8, ["class"])
                                            ], 32)
                                        ]),
                                        default: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_17, [
                                                _createVNode(_component_PricingTableUnitsModifierMenu, {
                                                    "input-field": _ctx.rowVariableQuantityField,
                                                    disabled: _ctx.isDocumentView,
                                                    open: _ctx.showVariableQuantityMenu,
                                                    onUpdateField: _ctx.handleUpdateVariableQuantityField,
                                                    onClose: _cache[5] || (_cache[5] = ($event) => (_ctx.showVariableQuantityMenu = false))
                                                }, null, 8, ["input-field", "disabled", "open", "onUpdateField"])
                                            ])
                                        ]),
                                        _: 1
                                    }, 8, ["show"])), [
                                        [_directive_click_outside, _ctx.handleCloseVariableQuantityMenu]
                                    ])
                                    : (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.rowVariableQuantityField.value), 1))
                            ], 64))
                            : (rowValue.columnId === _ctx.getColumnIdFromName(_ctx.columns, _ctx.EPricingTableColumn.Tax))
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    class: _normalizeClass(["formatted-tax-text", { strikethrough: _ctx.hasOptionalProductDeselected }]),
                                    "data-external": "editor-pricing-table-row-value-tax"
                                }, _toDisplayString(_ctx.getRowFormattedTax(_ctx.row, _ctx.columns, _ctx.currencySettings)), 3))
                                : (_openBlock(), _createElementBlock("div", {
                                    key: 2,
                                    class: _normalizeClass([
                                        'value',
                                        {
                                            strikethrough: _ctx.hasOptionalProductDeselected,
                                        },
                                    ])
                                }, _toDisplayString(_ctx.getFormat(rowValue)), 3))
                    ], 2));
                }), 128)),
                (_ctx.showTotalPrice)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.isPreCalculated)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(["row-value total-price-column", { precalculated: _ctx.isPreCalculated }])
                            }, [
                                _createElementVNode("div", {
                                    class: _normalizeClass(['total-price', { strikethrough: _ctx.hasOptionalProductDeselected }])
                                }, _toDisplayString(_ctx.getFormattedPrice(_ctx.getRowTotalPrice(_ctx.isPreCalculated, _ctx.row, _ctx.columns, _ctx.fields))), 3),
                                _withDirectives(_createElementVNode("div", {
                                    tabindex: "0",
                                    class: _normalizeClass(["discount", { empty: _ctx.getRowDiscountValueIsEmpty(_ctx.columns, _ctx.getRowValues(_ctx.row)) }])
                                }, _toDisplayString(_ctx.getRowFormattedDiscount(_ctx.isPreCalculated, _ctx.row, _ctx.columns, _ctx.fields, _ctx.currencySettings)), 3), [
                                    [_vShow, _ctx.showDiscount]
                                ]),
                                _withDirectives(_createElementVNode("div", {
                                    class: _normalizeClass(['discounted-price'])
                                }, _toDisplayString(_ctx.getFormattedPrice(_ctx.getRowNetPrice(_ctx.isPreCalculated, _ctx.row, _ctx.columns, _ctx.fields))), 513), [
                                    [_vShow, _ctx.showDiscount]
                                ])
                            ], 2))
                            : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                _createElementVNode("div", _hoisted_20, [
                                    _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.getColumnDisplayName(_ctx.getColumnIdFromName(_ctx.columns, _ctx.EPricingTableColumn.TotalPrice), _ctx.columns)), 1),
                                    _createElementVNode("div", {
                                        class: _normalizeClass(["total-price", {
                                                strikethrough: _ctx.hasOptionalProductDeselected || _ctx.hasDiscount(_ctx.columns, _ctx.getRowValues(_ctx.row)),
                                            }])
                                    }, _toDisplayString(_ctx.currencyFormat(_ctx.getRowTotalPrice(_ctx.isPreCalculated, _ctx.row, _ctx.columns, _ctx.fields), _ctx.currencySettings)), 3)
                                ]),
                                _withDirectives(_createElementVNode("div", {
                                    tabindex: "0",
                                    class: _normalizeClass(["discount", {
                                            empty: _ctx.getRowDiscountValueIsEmpty(_ctx.columns, _ctx.getRowValues(_ctx.row)),
                                            strikethrough: _ctx.hasOptionalProductDeselected,
                                        }])
                                }, _toDisplayString(_ctx.getRowFormattedDiscount(_ctx.isPreCalculated, _ctx.row, _ctx.columns, _ctx.fields, _ctx.currencySettings)), 3), [
                                    [_vShow, _ctx.showDiscount]
                                ]),
                                _withDirectives(_createElementVNode("div", {
                                    class: _normalizeClass(["discounted-price", { strikethrough: _ctx.hasOptionalProductDeselected }])
                                }, _toDisplayString(_ctx.currencyFormat(_ctx.getRowNetPrice(_ctx.isPreCalculated, _ctx.row, _ctx.columns, _ctx.fields), _ctx.currencySettings)), 3), [
                                    [_vShow, _ctx.hasDiscount(_ctx.columns, _ctx.getRowValues(_ctx.row))]
                                ])
                            ]))
                    ], 64))
                    : _createCommentVNode("", true),
                _hoisted_22
            ], 4))
            : _createCommentVNode("", true)
    ]));
}
